import React from 'react';
import { AssistantCard } from './AssistantCard';
import { mockOfficeAgent, mockDataAgent, mockCodeAgent } from '../../../../__fixtures__/agents';
const meta = {
    title: 'Features/AIChatWidget/AssistantCard',
    component: AssistantCard
};
export default meta;
export const OfficeAgent = {
    args: { agent: mockOfficeAgent }
};
export const DataAgent = {
    args: { agent: mockDataAgent }
};
export const CodeAgent = {
    args: { agent: mockCodeAgent }
};
export const AllAgents = {
    render: () => (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 320 } },
        React.createElement(AssistantCard, { agent: mockOfficeAgent }),
        React.createElement(AssistantCard, { agent: mockDataAgent }),
        React.createElement(AssistantCard, { agent: mockCodeAgent })))
};
